// extracted by mini-css-extract-plugin
export default {"button":"GetOfferButton_button__Bmt4q","classDiv":"GetOfferButton_classDiv__MgW5Y"};